import React, { useState } from 'react';
import {
  Paper,
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  Box,
  Divider,
  Alert
} from '@mui/material';
import {
  Save as SaveIcon,
  Email as EmailIcon,
  Chat as SlackIcon
} from '@mui/icons-material';

function AlertSettings() {
  const [emailSettings, setEmailSettings] = useState({
    enabled: true,
    taskFailures: true,
    diskSpaceWarning: true,
    databaseSizeWarning: true,
    backupFailures: true,
    dailySummary: false,
    email: 'admin@example.com'
  });

  const [slackSettings, setSlackSettings] = useState({
    enabled: false,
    criticalOnly: true,
    webhook: ''
  });

  const [saved, setSaved] = useState(false);

  const handleEmailChange = (field, value) => {
    setEmailSettings(prev => ({
      ...prev,
      [field]: value
    }));
    setSaved(false);
  };

  const handleSlackChange = (field, value) => {
    setSlackSettings(prev => ({
      ...prev,
      [field]: value
    }));
    setSaved(false);
  };

  const handleSave = () => {
    // TODO: Save settings to backend
    console.log('Saving alert settings:', { emailSettings, slackSettings });
    setSaved(true);
    
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <Paper sx={{ p: 3 }}>
      {saved && (
        <Alert severity="success" sx={{ mb: 3 }}>
          Alert settings saved successfully!
        </Alert>
      )}

      <Grid container spacing={3}>
        {/* Email Notifications */}
        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" mb={2}>
            <EmailIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Email Notifications</Typography>
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={emailSettings.enabled}
                onChange={(e) => handleEmailChange('enabled', e.target.checked)}
              />
            }
            label="Enable email notifications"
          />

          <Box ml={4} mt={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={emailSettings.taskFailures}
                  onChange={(e) => handleEmailChange('taskFailures', e.target.checked)}
                  disabled={!emailSettings.enabled}
                />
              }
              label="Task failures"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={emailSettings.diskSpaceWarning}
                  onChange={(e) => handleEmailChange('diskSpaceWarning', e.target.checked)}
                  disabled={!emailSettings.enabled}
                />
              }
              label="Disk space > 80%"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={emailSettings.databaseSizeWarning}
                  onChange={(e) => handleEmailChange('databaseSizeWarning', e.target.checked)}
                  disabled={!emailSettings.enabled}
                />
              }
              label="Database size > 80%"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={emailSettings.backupFailures}
                  onChange={(e) => handleEmailChange('backupFailures', e.target.checked)}
                  disabled={!emailSettings.enabled}
                />
              }
              label="Backup failures"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={emailSettings.dailySummary}
                  onChange={(e) => handleEmailChange('dailySummary', e.target.checked)}
                  disabled={!emailSettings.enabled}
                />
              }
              label="Daily summary report"
            />
          </Box>

          <TextField
            fullWidth
            label="Email Address"
            value={emailSettings.email}
            onChange={(e) => handleEmailChange('email', e.target.value)}
            disabled={!emailSettings.enabled}
            sx={{ mt: 2 }}
          />
        </Grid>

        {/* Slack Integration */}
        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" mb={2}>
            <SlackIcon sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="h6">Slack Integration</Typography>
          </Box>

          <FormControlLabel
            control={
              <Checkbox
                checked={slackSettings.enabled}
                onChange={(e) => handleSlackChange('enabled', e.target.checked)}
              />
            }
            label="Enable Slack notifications"
          />

          <Box ml={4} mt={2}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={slackSettings.criticalOnly}
                  onChange={(e) => handleSlackChange('criticalOnly', e.target.checked)}
                  disabled={!slackSettings.enabled}
                />
              }
              label="Critical alerts only"
            />
          </Box>

          <TextField
            fullWidth
            label="Slack Webhook URL"
            value={slackSettings.webhook}
            onChange={(e) => handleSlackChange('webhook', e.target.value)}
            disabled={!slackSettings.enabled}
            placeholder="https://hooks.slack.com/services/..."
            sx={{ mt: 2 }}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />

      <Box display="flex" justifyContent="flex-end">
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleSave}
        >
          Save Settings
        </Button>
      </Box>
    </Paper>
  );
}

export default AlertSettings;

